export type SpeakResult = 'playing' | 'unsupported';

export function canSpeak(): boolean {
  return typeof window !== 'undefined' && typeof window.speechSynthesis !== 'undefined';
}

/**
 * Play an English pronunciation inline via Web Speech.
 * Must be called from a user gesture (the Play control). Never navigates.
 */
export function speakEnglishPronunciation(
  phrase: string,
  handlers: { onEnd?: () => void; onError?: () => void } = {},
): SpeakResult {
  if (!canSpeak()) {
    handlers.onError?.();
    return 'unsupported';
  }

  const synth = window.speechSynthesis;
  synth.cancel();

  const utter = new SpeechSynthesisUtterance(phrase);
  utter.lang = 'en-US';
  utter.rate = 0.8;
  utter.pitch = 1;
  const english = synth.getVoices().find((voice) => /^en([-_]|$)/i.test(voice.lang));
  if (english) utter.voice = english;

  utter.onend = () => handlers.onEnd?.();
  utter.onerror = () => handlers.onError?.();

  synth.speak(utter);
  // Chrome can stay paused after cancel(); resume so playback starts on tap.
  if (synth.paused) synth.resume();
  return 'playing';
}

export function stopSpeaking(): void {
  if (!canSpeak()) return;
  window.speechSynthesis.cancel();
}
